import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthStore } from './auth.store';
import { AppPaths } from '@core/routes/app-paths';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate, CanActivateChild {
  constructor(
    private authStore: AuthStore,
    private router: Router,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkRole(route);
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkRole(route);
  }

  private checkRole(route: ActivatedRouteSnapshot): boolean | UrlTree {
    // Get allowed roles from route data
    const allowedRoles = route.data['roles'] as string[];

    // First check if user is authenticated
    if (!this.authStore.isAuthenticated()) {
      return this.router.createUrlTree([AppPaths.AUTH.LOGIN]);
    }

    // If no specific roles required, allow access
    if (!allowedRoles || allowedRoles.length === 0) {
      return true;
    }

    // Check if user has one of the required roles
    const hasRole = this.checkUserRoles(allowedRoles);

    if (hasRole) {
      return true;
    }

    // User doesn't have required role, redirect to jobs (default page)
    return this.router.createUrlTree([AppPaths.JOBS]);
  }

  private checkUserRoles(allowedRoles: string[]): boolean {
    if (this.authStore.isAdmin() && allowedRoles.includes('admin')) {
      return true;
    }

    if (this.authStore.isDispatcher() && allowedRoles.includes('dispatcher')) {
      return true;
    }

    // Add other role checks as needed

    return false;
  }
}
